import React from 'react';
import classnames from 'classnames';
import Styled from 'styled';
import { FormattedMessage, FormattedDate } from 'react-intl';
import { Link } from 'react-router-dom';

import SVGIcon from 'lib/images/svg-pure-icon/svg-pure-icon';

import { displayedName } from 'four-nets/user/utils';
import Avatar from 'four-nets/avatar/avatar';
import feed from 'four-nets/icons/svg/icon_feed.svg';
import picture from 'four-nets/icons/svg/icon_picture.svg';
import moderator from 'four-nets/icons/svg/icon_moderator.svg';
import lock from 'four-nets/icons/svg/icon_lock.svg';

import { MemberFragment } from './member.graphql';
import { MemberRole } from './member.graphql.types';
import defaultStyles from './member.scss';


export interface Props extends MemberFragment {
    styles: typeof defaultStyles;
}

class Member extends React.PureComponent<Props> {
    render() {
        if (!this.props.user) {
            return null;
        }

        const { id, user, role, createdTime, postsCount, imagesCount, styles } = this.props;

        return (
            <li className={styles.member} key={id}>
                <div className={styles.avatarWrapper}>
                    <Avatar style={{avatar: styles.avatar}} user={user} />
                    {role === MemberRole.MEMBER_ROLE_MODERATOR || role === MemberRole.MEMBER_ROLE_CREATOR ? (
                        <SVGIcon src={moderator} className={styles.moderatorIcon} />
                    ) : role === MemberRole.MEMBER_ROLE_BLOCKED ? (
                        <SVGIcon src={lock} className={styles.moderatorIcon} />
                    ) : null}
                </div>
                <div>
                    <Link
                        to={
                            user.profile && user.profile.isVendor
                                ? `/catalog/vendor/${user.username}/`
                                : `/blog/${user.username}/`
                        }
                        className={styles.username}
                    >
                        {displayedName(user)}
                    </Link>
                    {role === MemberRole.MEMBER_ROLE_MODERATOR ? (
                        <div className={styles.moderator}>
                            <FormattedMessage id='GROUP_MODERATOR_SHORT' />
                        </div>
                    ) : role === MemberRole.MEMBER_ROLE_CREATOR ? (
                        <div className={styles.moderator}>
                            <FormattedMessage id='GROUP_OWNER' />
                        </div>
                    ) : null}
                    <div className={classnames(styles.row, styles.blockRow)}>
                        <FormattedMessage id='MEMBER_SINCE'>
                            {message => (
                                <FormattedDate
                                    value={new Date(createdTime)}
                                    year='numeric'
                                    month='numeric'
                                    day='2-digit'
                                >
                                    {(date: string) => (
                                        <span>
                                            {message} {date}
                                        </span>
                                    )}
                                </FormattedDate>
                            )}
                        </FormattedMessage>
                    </div>
                    <div className={styles.row}>
                        <SVGIcon src={feed} className={styles.icon} />
                        {postsCount}
                        &nbsp;
                        <SVGIcon src={picture} className={styles.icon} />
                        {imagesCount}
                    </div>
                </div>
                {this.props.children || null}
            </li>
        );
    }
}

export default Styled(defaultStyles)(Member);
